module.exports = __webpack_public_path__ + "img/ys2.2151dad7.png";